import { arbitrum, avalanche, base, gnosis, mainnet, optimism, unichain } from 'viem/chains'

import { AssetsGroup } from './types'
import { TokenSymbol } from '@/domain/types/TokenSymbol'

export const SUPPORTED_CHAINS = [mainnet, base, arbitrum, gnosis, optimism, unichain, avalanche] as const
export const SUPPORTED_CHAIN_IDS = SUPPORTED_CHAINS.map((chain) => chain.id)

export const farmStablecoinsEntryGroup: Record<1 | 8453, AssetsGroup> = {
  [mainnet.id]: {
    type: 'stablecoins',
    name: 'Stablecoins',
    assets: [TokenSymbol('DAI'), TokenSymbol('USDC'), TokenSymbol('USDS'), TokenSymbol('sDAI'), TokenSymbol('sUSDS')],
  },
  [base.id]: {
    type: 'stablecoins',
    name: 'Stablecoins',
    assets: [TokenSymbol('USDS'), TokenSymbol('sUSDS'), TokenSymbol('USDC')],
  },
}
